export default __webpack_public_path__ + "static/media/not-found-illustration.f3b92d71.svg";